export const localFormSpec = {
    "context": {
        "organization": "1000008",
        "configuration": "1"
    },
    "page": {
        "locale": "en-us",
        "title": "Request for Medical Records",
        "form": {
            "logo": {
                "src": "no-logo.png",
                "alt": "Your Logo Goes Here",
                "position": "center"
            },
            "styles": {
                "externalStyles": [],
                "logos": {
                    "captcha": {
                        "height": "auto",
                        "width": 172
                    },
                    "form": {
                        "height": "auto",
                        "width": 172
                    },
                    "summary": {
                        "height": "auto",
                        "width": 172
                    },
                    "confirmation": {
                        "height": "auto",
                        "width": 172
                    }
                },
                "heading": {
                    "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    // "fontSize": "1.637em",
                    "textAlign": "center",
                    "fontWeight": 700,
                    "color": "#325570",
                    "letterSpacing": "-.5px"
                },
                "section": {
                    "fontFamily": "Arial, system-ui, -apple-system, Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    "fontSize": "1.637em",
                    "fontWeight": 700,
                    "color": "#325570",
                    "letterSpacing": "-0.5px",
                    "borderColor": "#c6c5c670"
                },
                "paragraph": {
                    "fontFamily": "arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    "color": "black"
                },
                "disclaimer": {
                    "fontFamily": "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    "color": "black",
                    "fontSize": "1em",
                    "paddingBottom": "20px",
                    "fontWeight": "400"
                },
                "label": {
                    "fontFamily": "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    "color": "black",
                    "marginBottom": "0.2em",
                    "fontSize": "1em",
                    "fontWeight": "bold"
                },
                "hint": {
                    "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                    "fontSize": "1em",
                    "fontWeight": 400
                },
                "list": {
                    "fontFamily": "system-ui, -apple-system, Arial, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                    "color": "black",
                    "fontSize": "1em",
                    "fontWeight": "400"
                },
                "subList": {
                    "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                    "color": "black",
                    "fontSize": "1em",
                    "fontWeight": "400"
                },
                "error": {
                    "field": "",
                    "text": "",
                    "visual": ""
                },
                "buttons": {
                    "act": {
                        "backgroundColor": "#325570",
                        "color": "white",
                        "fontFamily": "Arial, system-ui, -apple-system, Arial, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                        "fontSize": "1em",
                        "fontWeight": "700",
                        "textTransform": "uppercase"
                    },
                    "cancel": {
                        "backgroundColor": "white",
                        "color": "#325570",
                        "fontFamily": "Arial, system-ui, -apple-system, Arial, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                        "fontSize": "1em",
                        "fontWeight": "700",
                        "textTransform": "uppercase"
                    }
                },
                "validationModal": {
                    "heading": {
                        "color": "white",
                        "backgroundColor": "red",
                        "padding": 10,
                        "fontWeight": "bold",
                        "fontSize": "1.5em"
                    },
                    "topMessage": {
                        "fontWeight": "bold",
                        "fontSize": "1em"
                    },
                    "sectionName": {
                        "fontSize": "1em",
                        "marginTop": "1em",
                        "marginBottom": "1em",
                        "borderBottom": "1px solid silver"
                    },
                    "message": {
                        "paddingLeft": 5
                    },
                    "bottomMessage": {
                        "marginTop": 20,
                        "fontSize": "1em",
                        "fontStyle": "italic"
                    },
                    "okButton": {
                        "backgroundColor": "green"
                    }
                }
            },
            "heading": {
                "text": "Request for Release of Medical Information!!"
            },
            "components": {
                "captcha": {
                    "header": {
                        "text": "To ensure safe and proper release of medical records, please complete the security check below.",
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
                            "fontSize": "27px",
                            "fontWeight": 700,
                            "color": "#919296",
                            "letterSpacing": "-0.5px"
                        }
                    },
                    "instruction": "Type the letters that appear in the image below",
                    "textBoxHint": "Enter text here",
                    "buttonText": "Submit"
                },
                "submitButton": {
                    "text": "Review Request"
                },
                "validationModal": {
                    "headingText": "Validation Errors",
                    "topMessageText": "Please correct the following errors: ",
                    "okButtonText": "Ok",
                    "messageTextPrefix": "-",
                    "bottomMessageText": "Please click Ok and then review and submit again after fixing the errors."
                },
                "summaryModal": {
                    "detailSummaryLabel": "Request Details",
                    "reppedPartyLabel": "Represented Party",
                    "header": {
                        "text": "Request Summary",
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                            "fontSize": "2em",
                            "fontWeight": 700,
                            "letterSpacing": "-0.6px",
                            "color": "#325570"
                        }
                    },
                    "section": {
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                            "fontSize": "1.25em",
                            "fontWeight": 700,
                            "letterSpacing": "-0.6px",
                            "lineHeight": "23px",
                            "borderColor": "#325570"
                        }
                    },
                    "label": {
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                            "fontSize": "0.875em",
                            "fontWeight": 700,
                            "textTransform": "uppercase"
                        }
                    },
                    "value": {
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                            "fontSize": "1em",
                            "fontWeight": 400
                        }
                    },
                    "disclaimer": {
                        "text": "By submitting this form, you agree to receive the requested records electronically at the email address you provided. This is the only method of delivery available at this time.",
                        "styles": {
                            "fontFamily": "Arial",
                            "color": "black",
                            "fontSize": 16,
                            "fontWeight": 700,
                            "marginTop": "0px",
                            "logo": {
                                "height": "28.06px",
                                "width": "97px"
                            }
                        }
                    },
                    "buttons": {
                        "submitLabel": "Submit",
                        "goBackLabel": "Go Back"
                    },
                    "styles": {
                        "logo": {
                            "width": "97px",
                            "height": "auto"
                        },
                        "color": "white",
                        "backgroundColor": "#F0F0F0",
                        "padding": 10,
                        "fontWeight": "bold",
                        "fontSize": "1.2em"
                    }
                },
                "selectorMatch": {
                    "title": "Previous Matching Entries",
                    "header": {
                        "styles": {
                            "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                            "fontSize": "32px",
                            "fontWeight": 700
                        }
                    },
                    "fields": {
                        "text": {
                            "styles": {
                                "fontFamily": "Arial, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', 'Noto Sans', sans-serif",
                                "fontSize": "1em",
                                "fontWeight": 400
                            }
                        },
                        "canvas": {
                            "passive": {
                                "backgroundColor": "white",
                                "color": "black"
                            },
                            "active": {
                                "backgroundColor": "#325570",
                                "color": "white"
                            }
                        }
                    },
                    "cancelButton": {
                        "text": "Close"
                    },
                    "submitButton": {
                        "text": "Select"
                    }
                }
            },
            "sections": {
                "repContactInfoSection": {
                    "active": true,
                    "title": "Patient Info",
                    "disclaimer": "",
                    "fields": {
                        "caseNumber": {
                            "type": "TextBox",
                            "label": "Case Number",
                            "hint": "Enter your case number or file number. You can reference this request by this number later.",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": ""
                                },
                                "maxLength": {
                                    "value": 30,
                                    "message": "No more than 30 characters please"
                                }
                            }
                        },
                        "repRole": {
                            "type": "RadioBox",
                            "label": "What party do you represent?",
                            "entries": [
                                {
                                    "value": "1",
                                    "label": "Plaintiff",
                                    "tooltip": ""
                                },
                                {
                                    "value": "2",
                                    "label": "Defendant",
                                    "tooltip": ""
                                }
                            ],
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Please select who you are representing"
                                }
                            }
                        },
                        "discloseToOrgName": {
                            "type": "TextBox",
                            "label": "Organization Name",
                            "hint": "Name of your organization or firm",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 100,
                                    "message": "Maximum 100 characters are allowed"
                                },
                                "required": {
                                    "value": true,
                                    "message": "Please enter your firm's name"
                                }
                            }
                        },
                        "PMName": {
                            "type": "TextBox",
                            "label": "MI",
                            "hint": "MI",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 1,
                                    "message": "Maximum 1 character is allowed"
                                }
                            }
                        },
                        "PFName": {
                            "type": "TextBox",
                            "label": "First Name",
                            "hint": "Your first name",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Your first name is required"
                                },
                                "maxLength": {
                                    "value": 30,
                                    "message": "Maximum 30 characters are allowed"
                                }
                            }
                        },
                        "PLName": {
                            "type": "TextBox",
                            "label": "Last Name",
                            "hint": "Your last name",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Last name is required"
                                },
                                "maxLength": {
                                    "value": 30,
                                    "message": "Maximum 30 characters are allowed"
                                }
                            }
                        },
                        "PDOB": {
                            hint: 'mm/dd/yyyy'
                        },
                        "PPhone": {
                            "type": "TextBox",
                            "label": "Phone",
                            "hint": "123-456-7890x1234",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "A contact phone is required"
                                },
                                "validPhone": {
                                    "message": "Phone number is not valid"
                                },
                                "maxLength": {
                                    "value": 17,
                                    "message": "Maximum 17 characters are allowed"
                                }
                            }
                        },
                        "Patient_Phone_Conform":{
                            "type": "TextBox",
                            "label": "Phone",
                            "hint": "123-456-7890x1234",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "A contact phone is required"
                                },
                                "validPhone": {
                                    "message": "Phone number is not valid"
                                },
                                "maxLength": {
                                    "value": 17,
                                    "message": "Maximum 17 characters are allowed"
                                }
                            }
                        },
                        "PFax": {
                            "type": "TextBox",
                            "label": "Fax",
                            "hint": "123-456-7890",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "A contact fax is required"
                                },
                                "validFax": {
                                    "message": "Fax number is not valid"
                                },
                                "maxLength": {
                                    "value": 20,
                                    "message": "Maximum 12 characters are allowed"
                                }
                            }
                        },
                        "PEmail": {
                            "type": "TextBox",
                            "label": "Email",
                            "hint": "hello@world.com",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Email is required"
                                },
                                "validEmail": {
                                    "message": "Email is not valid"
                                },
                                "maxLength": {
                                    "value": 50,
                                    "message": "Maximum 50 characters are allowed"
                                }
                            }
                        },
                        "Patient_Email_Conform": {
                            "type": "TextBox",
                            "label": "Email",
                            "hint": "hello@world.com",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Email is required"
                                },
                                "validEmail": {
                                    "message": "Email is not valid"
                                },
                                "maxLength": {
                                    "value": 50,
                                    "message": "Maximum 50 characters are allowed"
                                }
                            }
                        },
                        "PAddress1": {
                            "type": "TextBox",
                            "label": "Organization Mailing Address",
                            "hint": "Building Number & Street Address",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Address is required"
                                },
                                "maxLength": {
                                    "value": 50,
                                    "message": "Maximum 50 characters are allowed"
                                }
                            }
                        },
                        "PAddress2": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "Suite Number, if applicable",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": "Address is required"
                                },
                                "maxLength": {
                                    "value": 50,
                                    "message": "Maximum 50 characters are allowed"
                                }
                            }
                        },
                        "PCity": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "City",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "City is required"
                                },
                                "maxLength": {
                                    "value": 30,
                                    "message": "Maximum 30 characters are allowed"
                                }
                            }
                        },
                        "PState": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "State",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "State is required"
                                },
                                "maxLength": {
                                    "value": 2,
                                    "message": "Maximum 2 characters are allowed"
                                }
                            }
                        },
                        "PZip": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "Zip Code",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Zip code is required"
                                },
                                "maxLength": {
                                    "value": 10,
                                    "message": "Maximum 10 characters are allowed"
                                },
                                "validZipcode": {
                                    "message": "Zip code is not valid"
                                }
                            }
                        }
                    }
                },
                "patientInformationSection": {
                    "active": true,
                    "title": "Patient Information",
                    "fields": {
                        // "patientInfoFirstName": {
                        //     "type": "TextBox",
                        //     "label": "First Name",
                        //     "hint": "Patient's First Name",
                        //     "tooltip": "",
                        //     "active": true,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Patient's first name is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 40,
                        //             "message": "Maximum 40 characters are allowed"
                        //         }
                        //     }
                        // },
                        // "patientInfoMiddleInitial": {
                        //     "type": "TextBox",
                        //     "label": "MI",
                        //     "hint": "MI",
                        //     "tooltip": "",
                        //     "active": true,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": false
                        //         },
                        //         "maxLength": {
                        //             "value": 1,
                        //             "message": "Only 1 character is allowed"
                        //         }
                        //     }
                        // },
                        // "patientInfoLastName": {
                        //     "type": "TextBox",
                        //     "label": "Last Name",
                        //     "hint": "Patient's last name",
                        //     "tooltip": "",
                        //     "active": true,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Patient's last name is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 40,
                        //             "message": "Maximum 40 characters are allowed"
                        //         }
                        //     }
                        // },
                        // "patientInfoDob": {
                        //     "type": "TextBox",
                        //     "label": "Date of Birth",
                        //     "hint": "mm/dd/yyyy",
                        //     "tooltip": "",
                        //     "active": true,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Patient's date of birth is required"
                        //         },
                        //         "minimumYearsOld": {
                        //             "value": 18,
                        //             "message": "Patient indicates a minor. Please upload a document with parental representative signature"
                        //         },
                        //         "notFutureDate": {
                        //             "message": "Date can't be in the future"
                        //         },
                        //         "maxYearsAgo": {
                        //             "value": 200,
                        //             "message": "Date of birth cannot be more than 200 years ago"
                        //         }
                        //     }
                        // },
                        // "patientInfoOtherName": {
                        //     "type": "TextBox",
                        //     "label": "Maiden or Other Name",
                        //     "hint": "Patient's maiden or other name",
                        //     "tooltip": "",
                        //     "active": true,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": false,
                        //             "message": ""
                        //         },
                        //         "maxLength": {
                        //             "value": 40,
                        //             "message": "Maximum 40 characters are allowed"
                        //         }
                        //     }
                        // },
                        // "patientInfoMrn": {
                        //     "type": "TextBox",
                        //     "label": "MRN",
                        //     "hint": "Medical Record Number",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Mrn is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 10,
                        //             "message": "Maximum 10 characters are allowed"
                        //         }
                        //     }
                        // },
                        // "patientInfoEmail": {
                        //     "type": "TextBox",
                        //     "label": "Email",
                        //     "hint": "hello@world.com",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Email is required"
                        //         },
                        //         "validEmail": {
                        //             "message": "Email is not valid"
                        //         },
                        //         "maxLength": {
                        //             "value": 50,
                        //             "message": "Maximum 50 characters"
                        //         }
                        //     }
                        // },
                        // "patientInfoEmailConfirmation": {
                        //     "type": "TextBox",
                        //     "label": "Email Confirmation",
                        //     "hint": "hello@world.com",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Email confirmation is required"
                        //         },
                        //         "validEmail": {
                        //             "message": "Email is not valid"
                        //         },
                        //         "maxLength": {
                        //             "value": 50,
                        //             "message": "Maximum 50 characters"
                        //         },
                        //         "mustMatch": {
                        //             "value": "patientInfoEmail",
                        //             "message": "The email address you entered do not match. You will not be allowed to submit your request until this is corrected."
                        //         }
                        //     }
                        // },
                        // "patientInfoPhone": {
                        //     "type": "TextBox",
                        //     "label": "Phone",
                        //     "hint": "123-456-7890",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Phone is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 12,
                        //             "message": "Maximum 12 characters"
                        //         },
                        //         "validPhone": {
                        //             "message": "Phone number is not valid"
                        //         }
                        //     }
                        // },
                        // "patientInfoPhoneConfirmation": {
                        //     "type": "TextBox",
                        //     "label": "Phone Confirmation",
                        //     "hint": "123-456-7890",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Confirmation phone is required"
                        //         },
                        //         "validPhone": {
                        //             "message": "Confirmation phone number is not valid"
                        //         },
                        //         "maxLength": {
                        //             "value": 12,
                        //             "message": "Maximum 12 characters"
                        //         },
                        //         "mustMatch": {
                        //             "value": "patientInfoPhone",
                        //             "message": "The phone number you entered do not match. You will not be allowed to submit your request until this is corrected."
                        //         }
                        //     }
                        // },
                        // "patientInfoAddressLine1": {
                        //     "type": "TextBox",
                        //     "label": "Mailing Address",
                        //     "hint": "Address line 1",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Address is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 50,
                        //             "message": "Maximum 50 characters"
                        //         }
                        //     }
                        // },
                        // "patientInfoAddressLine2": {
                        //     "type": "TextBox",
                        //     "label": "Other",
                        //     "hint": "Address line 2",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Address 2 is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 50,
                        //             "message": "Maximum 50 characters"
                        //         }
                        //     }
                        // },
                        // "patientInfoCity": {
                        //     "type": "TextBox",
                        //     "label": "City",
                        //     "hint": "City",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "City is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 30,
                        //             "message": "Maximum 30 characters"
                        //         }
                        //     }
                        // },
                        // "patientInfoState": {
                        //     "type": "TextBox",
                        //     "label": "State",
                        //     "hint": "State",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "State is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 2,
                        //             "message": "Maximum 2 characters"
                        //         }
                        //     }
                        // },
                        // "patientInfoZip": {
                        //     "type": "TextBox",
                        //     "label": "Zip",
                        //     "hint": "Zip",
                        //     "tooltip": "",
                        //     "active": false,
                        //     "otherNames": {
                        //         "pdf": "",
                        //         "vrm": ""
                        //     },
                        //     "validations": {
                        //         "required": {
                        //             "value": true,
                        //             "message": "Zipcode is required"
                        //         },
                        //         "maxLength": {
                        //             "value": 10,
                        //             "message": "Maximum 10 characters"
                        //         },
                        //         "validZipcode": {
                        //             "message": "Zipcode is not valid"
                        //         }
                        //     }
                        // }
                    }
                },
                "informationToReleaseSection": {
                    "active": true,
                    "title": "Information to Release",
                    "fields": {
                        "certBox": {
                            "type": "CheckBox",
                            "active": true,
                            "summaryText": "Certification is required for release of this information",
                            "entries": [
                                {
                                    "key": "1",
                                    "value": "Certification is required for release of this information",
                                    "tooltip": ""
                                }
                            ]
                        },
                        "infoToReleaseGroup": {
                            "type": "CheckBox",
                            "entries": [
                                {
                                    "tag": "0",
                                    "key": "16220",
                                    "value": "Medical Records Abstract",
                                    "tooltip": "Medical Records Abstract may include an abstract of the medical record and provides you and/or your other healthcare providers just those documents that are needed for continuing care. The abstract includes: History & Physical, Operative Report, Pathology Report, Consultation(s), test reports and a discharge summary"
                                },
                                {
                                    "tag": "1",
                                    "key": "16221",
                                    "value": "History & Physical",
                                    "tooltip": "History & Physical may include a chief complaint, history of present illness, past medical history, social and family history, medication list, review of systems, physical exam, assessment and plan"
                                },
                                {
                                    "tag": "2",
                                    "key": "16222",
                                    "value": "Discharge Summary",
                                    "tooltip": "Discharge Summary may include final diagnoses, consultations (if any), a summary of labs, x-rays and procedures done, a summary of the day-to-day activity during the hospital stay, a list of discharge medications and recommendations, and follow-up appointments"
                                },
                                {
                                    "tag": "3",
                                    "key": "16223",
                                    "value": "Consultation Report(s)",
                                    "tooltip": "Consultation Report(s) may include examinations performed by a specialist. It may also include the reason for consultation, a review of past and current history, medication review, an exam, and/or assessment and recommendations"
                                },
                                {
                                    "tag": "4",
                                    "key": "16224",
                                    "value": "Outpatient / Physician Office Record(s)",
                                    "tooltip": "Outpatient / Physician Office Record(s)"
                                },
                                {
                                    "tag": "5",
                                    "key": "16225",
                                    "value": "Emergency Room Record(s)",
                                    "tooltip": "Emergency Room (ER) Record(s) may include ER physician report(s) and test report(s)"
                                },
                                {
                                    "tag": "6",
                                    "key": "16226",
                                    "value": "Operative Report(s)",
                                    "tooltip": "Operative Report(s) may include a description of a surgical procedure along with any complications or findings"
                                },
                                {
                                    "tag": "7",
                                    "key": "16227",
                                    "value": "Radiology Report(s)",
                                    "tooltip": "Radiology Report(s) may include reports of findings from X-rays, CT Scans and MRIs"
                                },
                                {
                                    "tag": "8",
                                    "key": "16228",
                                    "value": "Laboratory Results",
                                    "tooltip": "Laboratory Results"
                                },
                                {
                                    "tag": "9",
                                    "key": "16229",
                                    "value": "Pathology Report(s)",
                                    "tooltip": "Pathology Report(s) may include a description of findings regarding a tissue sample of some sort (typically related to a biopsy)"
                                },
                                {
                                    "tag": "10",
                                    "key": "16233",
                                    "value": "Cardiology Report(s)",
                                    "tooltip": "Cardiology Report(s) may include stress tests, EKG, echocardiograms, holter monitors, cardiac catheterization reports and event monitors"
                                },
                                {
                                    "tag": "11",
                                    "key": "16237",
                                    "value": "Physician Office Note(s)",
                                    "tooltip": "Physician Office Note(s) may include patient history, examination results, test results, medication (prescribed, dispensed or administered), current problem list, treatment plan and recommendations for follow up"
                                },
                                {
                                    "tag": "12",
                                    "key": "16238",
                                    "value": "Ambulatory Surgery",
                                    "tooltip": "Ambulatory Surgery"
                                },
                                {
                                    "tag": "13",
                                    "key": "16239",
                                    "value": "Admission",
                                    "tooltip": "Medical record(s) for dates of service requested"
                                },
                                {
                                    "tag": "14",
                                    "key": "otherItem",
                                    "value": "",
                                    "tooltip": "Any other item not listed here"
                                }
                            ],
                            "label": "Select the types of medical information you would like released",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "You must select at least one information to release"
                                }
                            }
                        },
                        "infoToReleaseGroupOther": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "Other information",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 31,
                                    "message": "Maximum 31 characters are allowed"
                                },
                                "required": {
                                    "message": "Please enter the other information or uncheck the other box"
                                }
                            }
                        },
                        "txtotherrecords": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "Other information",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 31,
                                    "message": "Maximum 31 characters are allowed"
                                },
                                "required": {
                                    "message": "Please enter the other information or uncheck the other box"
                                }
                            }
                        },
                        "dosfrom": {
                            "type": "TextBox",
                            "label": "From Date",
                            "hint": "mm/dd/yyyy",
                            "tooltip": "Range begins at this date",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "From date is required"
                                },
                                "notFutureDate": {
                                    "message": "From date cannot be in the future"
                                },
                                "notBeforeDate": {
                                    "ref": "patientInfoDob",
                                    "message": "From date must be after patient's date of birth"
                                }
                            }
                        },
                        "dosto": {
                            "type": "TextBox",
                            "label": "To Date",
                            "hint": "mm/dd/yyyy",
                            "tooltip": "Range ends at this date",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "To date is required"
                                },
                                "notFutureDate": {
                                    "message": "To date cannot be in the future"
                                },
                                "notBeforeDate": {
                                    "ref": "releaseFromDate",
                                    "message": "To date must be after from date"
                                }
                            }
                        }
                    }
                },
                "supportingDocsSection": {
                    "active": true,
                    "title": "Supporting Documentation",
                    "fields": {
                        "disclaimers": {
                            "header": "Please note",
                            "requestNotice": "<strong>We will also email you a copy of this submission</strong>. This form will serve as the formal request for records from your firm. There is no need to submit a request on your firm's letterhead.",
                            "emailNotice": "When your requested records are ready, we will email you a link to the records at the email address provided above.",
                            "authNotice": "<strong>You must attach a fully executed Authorization below</strong>. In addition, please be sure to include additional documentation to support the authorization validation process such as Power of Attorney, Will, Proof of Guardianship, or Letter of Representation.",
                            "type": "disclaimers"
                        },
                        // "supportingDoc": {}
                        "supportingDoc": {
                            "label": "Files to upload (up to 3 individual PDF files)",
                            "hint": "Browse to choose file (maximum 15mb)",
                            "type": "fileUpload",
                            "validations": {
                                "required": {
                                    "message": "A photo ID and recent portrait photo of yourself are required"
                                },
                                "fileType": {
                                    "message": "Only PDF files are allowed"
                                },
                                "fileSize": {
                                    "message": "Each file must be smaller than 15MB"
                                },
                                "fileLimit": {
                                    "message": "Too many files: Please provide a maximum of 2 PDF files"
                                },
                                "fileMinimum": {
                                    "message": "Too few files: Please provide two PDF files"
                                }
                            }
                        }
                    }
                },
                "authorizationToReleaseSection": {
                    "active": true,
                    "title": "Medical Facilities Requested",
                    "fields": {
                        "facilitiesGroup": {
                            "type": "CheckBox",
                            "entries": [
                                {
                                    "key": "CBDNetwork",
                                    "value": "CBC Trial Works"
                                },
                                {
                                    "key": "otherFac",
                                    "value": "List any specific facilities or providers at CBC Trial Works"
                                }
                            ],
                            "label": "Facility or Provider",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "You must select at least one facility or provider"
                                }
                            }
                        },
                        "inputAuthorizeA": { },
                        "inputDisclosePhysicians": { },
                        "facilityOrPhysician": { },
                        "discloseTo": { },
                        "physiciansGroup": {
                            "type": "CheckBox",
                            "entries": [
                                {
                                    "key": "cbcPhysician",
                                    "value": "CBC Trial Works Physician Group"
                                }
                            ],
                            "label": "",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": "You must select all, or name a physician"
                                }
                            }
                        },
                        "allOrNameGroup": {
                            "type": "RadioBox",
                            "entries": [
                                {
                                    "key": "all",
                                    "value": "All Physicians"
                                },
                                {
                                    "key": "namePhysicians",
                                    "value": "Name Physicians"
                                }
                            ],
                            "label": "",
                            "hint": "",
                            "tooltip": "",
                            "active": false,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": "You must select either all or name a physician"
                                }
                            }
                        },
                        "otherFac": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "List any specific facilities or providers at CBC Trial Works",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 31,
                                    "message": "Maximum 31 characters are allowed"
                                },
                                "required": {
                                    "message": "Please enter the other item you selected"
                                }
                            }
                        },
                        
                        "RPhone": { },
                        "RFax": { },
                        "RAddress1": { },
                        "RAddress2": { },
                        "RCity": { },
                        "RState": { },
                        "RZip": { },
                        "REmail": { },
                        
                        "namedPhysicians": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "If multiple physicians, separate each physicians's name with a comma",
                            "tooltip": "",
                            "active": false,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": "You must enter a physician name"
                                }
                            }
                        }
                    }
                },
                "discloseToSection": {
                    "active": false,
                    "title": "Disclose To",
                    "disclaimer": "A fee for medical record copies may apply. A patient whose records are copied and sent to another healthcare provider for the purposes of continuing to receive medical care **does not** pay a fee for medical record copies. Request for medical record copies for any use other than medical care may be subject to a fee. If a fee does apply, you will be notified prior to your request being processed. The HIPAA Privacy Rule permits healthcare providers to impose a reasonable, cost-based fee to an individual requesting a copy of medical records. The fee may only include the cost of labor, supplies and postage.",
                    "fields": {
                        "discloseToEntityGroup": {
                            "type": "RadioBox",
                            "label": "to disclose to",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "entries": [
                                {
                                    "key": "me",
                                    "value": "Me"
                                },
                                {
                                    "key": "namedPersonEntity",
                                    "value": "Named person or entity"
                                }
                            ],
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "To disclose to is required"
                                }
                            }
                        },
                        "discloseToName": {
                            "type": "TextBox",
                            "label": "Name",
                            "hint": "Name...",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Name is required"
                                },
                                "maxLength": {
                                    "value": 524288,
                                    "message": "Maximum 524288 character"
                                }
                            }
                        },
                        "discloseToPhone": {
                            "type": "TextBox",
                            "label": "Phone",
                            "hint": "123-456-7890*",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Phone is required"
                                },
                                "maxLength": {
                                    "value": 12,
                                    "message": "Maximum 12 character"
                                },
                                "validPhone": {
                                    "message": "Phone number is not valid"
                                }
                            }
                        },
                        "discloseToFax": {
                            "type": "TextBox",
                            "label": "Fax",
                            "hint": "123-456-7890*",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "validPhone": {
                                    "message": "Fax number is not valid"
                                },
                                "maxLength": {
                                    "value": 524288,
                                    "message": "Maximum 524288 character"
                                }
                            }
                        },
                        "discloseToAddressLine1": {
                            "type": "TextBox",
                            "label": "Mailing Address",
                            "hint": "Address line 1",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Address is required"
                                },
                                "maxLength": {
                                    "value": 65,
                                    "message": "Maximum 65 characters"
                                }
                            }
                        },
                        "discloseToAddressLine2": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "Address line 2",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": false,
                                    "message": "Address is required"
                                },
                                "maxLength": {
                                    "value": 65,
                                    "message": "Maximum 65 characters"
                                }
                            }
                        },
                        "discloseToCity": {
                            "type": "TextBox",
                            "label": "City",
                            "hint": "City",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "City is required"
                                },
                                "maxLength": {
                                    "value": 10,
                                    "message": "Maximum 10 characters"
                                }
                            }
                        },
                        "discloseToState": {
                            "type": "TextBox",
                            "label": "State",
                            "hint": "State",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "State is required"
                                },
                                "maxLength": {
                                    "value": 2,
                                    "message": "Maximum 2 characters"
                                }
                            }
                        },
                        "discloseToZip": {
                            "type": "TextBox",
                            "label": "Zip",
                            "hint": "Zip",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "Zipcode is required"
                                },
                                "maxLength": {
                                    "value": 10,
                                    "message": "Maximum 10 characters"
                                },
                                "validZipcode": {
                                    "message": "Zipcode is not valid"
                                }
                            }
                        }
                    }
                },
                "deliveryMethodSection": {
                    "active": true,
                    "title": "Delivery Method",
                    "fields": {
                        "deliveryMethodGroup": {
                            "type": "RadioBox",
                            "entries": [
                                {
                                    "key": "2",
                                    "value": "Electronic copy of records",
                                    "tooltip": "tip-electronicCopy"
                                },
                                {
                                    "key": "5",
                                    "value": "Mail Paper Records",
                                    "tooltip": "tip-electronicCopy"
                                },
                                {
                                    "key": "7",
                                    "value": "CD/DVD",
                                    "tooltip": "cd/dvd"
                                }
                                // {
                                //     "key": "4",
                                //     "value": "Pick up records at ...",
                                //     "tooltip": "tip-electronicCopy"
                                // }
                            ],
                            "label": "Electronic delivery: You will receive an email with a link to download your records electronically.",
                            "hint": "",
                            "tooltip": "",
                            "active": false,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "You must select a delivery method"
                                }
                            }
                        },
                        "releasemodePdf": ""
                    }
                },
                "purposeOfDisclosureSection": {
                    "active": false,
                    "title": "Purpose of Disclosure",
                    "fields": {
                        "disclosurePurposeGroup": {
                            "type": "RadioBox",
                            "entries": [
                                {
                                    "key": "0",
                                    "value": "Individual’s request",
                                    "tooltip": "tip-individualRequest"
                                },
                                {
                                    "key": "1",
                                    "value": "Medical Care",
                                    "tooltip": "tip-medicalCare"
                                },
                                {
                                    "key": "2",
                                    "value": "Insurance",
                                    "tooltip": "tip-insurance"
                                },
                                {
                                    "key": "3",
                                    "value": "Immunization",
                                    "tooltip": "tip-immunization"
                                },
                                {
                                    "key": "4",
                                    "value": "Legal",
                                    "tooltip": "tip-legal"
                                },
                                {
                                    "key": "5",
                                    "value": "Other",
                                    "tooltip": "tip-other"
                                }
                            ],
                            "label": "The purpose(s) for which disclosure is authorized (check where applicable): ",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "You must select the purpose of disclosure"
                                }
                            }
                        },
                        "disclosurePurposeGroupOther": {
                            "type": "TextBox",
                            "label": "",
                            "hint": "",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "required": {
                                    "value": true,
                                    "message": "You must the purpose of disclosure when you select other"
                                },
                                "maxLength": {
                                    "value": 10,
                                    "message": "Maximum 10 characters..."
                                }
                            }
                        }
                    }
                },
                "disclosureOfSensitiveInformation": {
                    "active": true,
                    "title": "Disclosure of Sensitive Information",
                    "disclaimer": "**From the selections below, choose any medical information you would like excluded from this disclosure.**",
                    "fields": {
                        "sensitiveInfo": {
                            "type": "CheckBox",
                            "entries": [
                                {
                                    "value": "excludepsy",
                                    "label": "Psychological/Psychiatric conditions",
                                    "tooltip": "tip-mentalHealth"
                                },
                                {
                                    "value": "excludedrug",
                                    "label": "Drug and/or alcohol abuse diagnosis and/or treatment",
                                    "tooltip": "tip-alcoholDrug"
                                },
                                {
                                    "value": "excludeHIV",
                                    "label": "HIV/AIDS diagnosis and/or treatment ",
                                    "tooltip": "tip-hivAids"
                                },
                                {
                                    "value": "excludeSTD",
                                    "label": "Sexually transmitted disease(s) diagnosis and/or testing",
                                    "tooltip": "tip-geneticTesting"
                                },
                                {
                                    "value": "excludegenetics",
                                    "label": "Genetic Testing ",
                                    "tooltip": "tip-other"
                                },
                                {
                                    "value": "authorizeAll",
                                    "label": "I authorize the disclosure of ALL sensitive information",
                                    "tooltip": "tip-legal"
                                },
                                {
                                    "value": "notAuthorizeAll",
                                    "label": "I DO NOT authorize the disclosure of ANY sensitive information ",
                                    "tooltip": "tip-other"
                                }
                            ],
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            }
                        },
                        "excludepsy": "",
                        "excludeHIV": ""
                    }
                },
                "additionalInfoSection": {
                    "active": true,
                    "title": "Additional Information",
                    "disclaimer": "Are you representing the",
                    "fields": {
                        "repDesc": {
                            "type": "TextBox",
                            "label": "In the box below please provide any additional information pertinent to this request.",
                            "hint": "Additional information. Max 4000 characters allowed.",
                            "tooltip": "",
                            "active": true,
                            "otherNames": {
                                "pdf": "",
                                "vrm": ""
                            },
                            "validations": {
                                "maxLength": {
                                    "value": 4000,
                                    "message": "Maximum 4000 characters"
                                }
                            }
                        }
                    }
                },
                "releaseDatesSection": {
                    "active": true,
                    "title": "",
                    "disclaimer": "",
                    "fields": {
                        "todaysDate": {
                            "type": "TextBox",
                            "label": "Today's Date",
                            "hint": "",
                            "tooltip": "",
                            "active": true
                        },
                        "consentExpirationDate": {
                            "age": 365,
                            "type": "TextBox",
                            "label": "Consent Expiration Date",
                            "hint": "",
                            "tooltip": "tip-consentExpirationDate",
                            "active": false
                        }
                    }
                }
            },
            "validations": {
                "releaseStartAfterDateOfBirth": {
                    "ref": "patientInfoDob",
                    "message": "From date must be after date of birth"
                }
            }
        }
    }
}